'use strict';

angular.module('mean.invoices').factory('createInvoiceService', ['$filter', 'Invoices', 'toaster', '$q', 'aceUtils',
    function($filter, Invoices, toaster, $q, aceUtils) {
        
        var create = function(user, data, invoice_string, start_date, end_date) {
            console.log(data)
            var city, statezip, state, zip, parts;
            [city, statezip] = user.address_two.split(/,\s*/);
            parts = statezip.split(/\s+/);
            zip = parts.pop();
            state = parts.join(" ");

            var to = {
                name: user.company_name,
                address: user.address_one,
                city: city,
                state: state,
                zip: zip,
                phone: user.company_phone,
                email: user.company_email
            }
            var from = {
                name: 'Actual Cost Engineering LLC',
                address: '231 Encantado Cyn',
                city: 'RSM',
                state: 'CA',
                zip: '92688',
                phone: '(949) 412-6701',
                email: 'brandonwilson@aceconstructionsoftware.com'
            }
            _.each(data, function(item) {
                //item.project_id = angular.copy(item._id);
                _.each(item.lots, function(lot) {
                    lot.date_scheduled = new Date(lot.date_scheduled);
                    lot.last_reschedule = (lot.last_reschedule === 'N/A')? '': new Date(lot.last_reschedule);
                    lot.price = lot.invoice_cost;
                });
                item.project_type = item.projectType;
                item.total_cost = item.invoice_cost;
            });

            var invoice = new Invoices({
                company_code: user.company_code,
                trade_code: user.trade_code,
                year: moment().year(),
                month: aceUtils.padDigits(moment(start_date).month()+1, 2),
                invoice_string: invoice_string,
                start_date: start_date,
                end_date: end_date,
                to: to,
                from: from,
                invoice_date: new Date(),
                due_date: new Date(moment().add(14, 'days')),
                total: data.invoice_cost,
                details: data
            });
            console.log(invoice);

            invoice.$save(function(success) {
                toaster.pop('success', 'Invoice Created');
            }, function(error) {
                toaster.pop('error', 'Invoice Creation Error', error);
            });
            // var deferred = $q.defer();
            // var month = aceUtils.padDigits(moment().month()+1, 2); 
            // var year = moment().year();

            // //'type': 'NumbersOnly'
            // Invoices.query({'company_code': company_code, 'trade_code': trade_code, 
            //     'month': month, 'year': year }, function(invoices) {
            //     var month = aceUtils.padDigits(moment().month()+1, 2); 
            //     var year = moment().year();

            //     var modifier = '';
            //     if(invoices.length) {
            //         //we already have a generated invoice for this month
            //         //might need to return an error in the future but for
            //         //now add a modifier to the returned string
            //         modifier = '-' + invoices.length
            //     }
                
            //     var invoice_string = year + '-' + month + modifier;
            //     deferred.resolve(invoice_string);
            // });

            // return deferred.promise;
        }
        
        return {
            create: create
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/invoices/public/services/create-invoice-service.js